'use client';

import { useState } from 'react';
import { V2Layout, RevealSection, useV2Lang, Eyebrow, Rule, ACCENT, HAIRLINE, PageHeader, DisplayTitle } from '../_layout';

const COPY = {
  CN: {
    kicker: '联系我们',
    title: '想做点什么？\n写信告诉我们。',
    lede: '巡演合作、艺人邀约、媒体咨询、参与翻译工作坊、捐赠——欢迎联系，我们认真回复每一封。',
    form: {
      title: '发送消息',
      name: '姓名',
      namePh: '您的姓名 / 团队 / 机构名称',
      email: '邮箱',
      emailPh: 'name@example.com',
      subject: '主题',
      subjectPh: '例如：巡演合作 / 演出邀约 / 媒体咨询',
      message: '内容',
      messagePh: '简单介绍一下您想谈的事——项目背景、时间、城市、合作形式等。',
      submit: '发送',
      sending: '发送中…',
      success: '感谢您的留言，我们已收到。',
      error: '发送失败，请稍后再试或直接发邮件。',
    },
    direct: {
      title: '或者直接发邮件',
      items: [
        { label: '总联络', email: 'pathin@pathin.eu' },
        { label: 'GraviLens · 音乐 / 巡演', email: 'gravilens@pathin.eu' },
        { label: '桥洞 · 诗歌 / 翻译', email: 'qiaodong@pathin.eu' },
        { label: '项目负责人', email: 'lijing@pathin.eu' },
      ],
    },
    address: { title: '注册地址', body: 'PathIN e.V.\nArabellastraße 5, Apt. 416\n81925 München\nDeutschland' },
    social: { title: '社交', items: [
      { label: 'Instagram · PathIN', url: 'https://instagram.com/pathin.official', display: '@pathin.official' },
      { label: 'Instagram · GraviLens', url: 'https://instagram.com/gravilens.music', display: '@gravilens.music' },
      { label: '小红书 · GraviLens', url: 'https://xhslink.com/m/2TVoKkmKWjn', display: 'GraviLens · 引力透镜' },
    ] },
  },
  EN: {
    kicker: 'Contact',
    title: 'Want to make\nsomething happen?\nWrite to us.',
    lede: 'Tour collaborations, artist booking, press inquiries, joining translation workshops, donations — we read and answer every email seriously.',
    form: {
      title: 'Send a message',
      name: 'Name', namePh: 'Your name / band / organization',
      email: 'Email', emailPh: 'name@example.com',
      subject: 'Subject', subjectPh: 'e.g. Tour collaboration / Booking / Press inquiry',
      message: 'Message', messagePh: "Briefly describe what you'd like to discuss — project background, dates, cities, type of collaboration.",
      submit: 'Send', sending: 'Sending…',
      success: 'Thank you — we have received your message.',
      error: 'Sorry, something went wrong. Please email us directly.',
    },
    direct: {
      title: 'Or email us directly',
      items: [
        { label: 'General', email: 'pathin@pathin.eu' },
        { label: 'GraviLens · Music / Tours', email: 'gravilens@pathin.eu' },
        { label: 'Qiaodong · Poetry / Translation', email: 'qiaodong@pathin.eu' },
        { label: 'Head of Projects', email: 'lijing@pathin.eu' },
      ],
    },
    address: { title: 'Registered address', body: 'PathIN e.V.\nArabellastraße 5, Apt. 416\n81925 München\nDeutschland' },
    social: { title: 'Social', items: [
      { label: 'Instagram · PathIN', url: 'https://instagram.com/pathin.official', display: '@pathin.official' },
      { label: 'Instagram · GraviLens', url: 'https://instagram.com/gravilens.music', display: '@gravilens.music' },
      { label: 'Xiaohongshu · GraviLens', url: 'https://xhslink.com/m/2TVoKkmKWjn', display: 'GraviLens · 引力透镜' },
    ] },
  },
  DE: {
    kicker: 'Kontakt',
    title: 'Etwas vorhaben?\nSchreiben Sie uns.',
    lede: 'Tour-Kooperationen, Künstler:innen-Booking, Presseanfragen, Workshop-Anmeldungen, Spenden — wir lesen und beantworten jede Nachricht ernsthaft.',
    form: {
      title: 'Nachricht senden',
      name: 'Name', namePh: 'Ihr Name / Band / Organisation',
      email: 'E-Mail', emailPh: 'name@example.com',
      subject: 'Betreff', subjectPh: 'z. B. Tour-Kooperation / Booking / Presseanfrage',
      message: 'Nachricht', messagePh: 'Kurz beschreiben, worum es geht — Projekt, Daten, Städte, Art der Zusammenarbeit.',
      submit: 'Absenden', sending: 'Wird gesendet…',
      success: 'Vielen Dank — wir haben Ihre Nachricht erhalten.',
      error: 'Etwas ist schief gegangen. Bitte schreiben Sie uns direkt eine E-Mail.',
    },
    direct: {
      title: 'Oder direkt per E-Mail',
      items: [
        { label: 'Allgemein', email: 'pathin@pathin.eu' },
        { label: 'GraviLens · Musik / Touren', email: 'gravilens@pathin.eu' },
        { label: 'Qiaodong · Poesie / Übersetzung', email: 'qiaodong@pathin.eu' },
        { label: 'Projektleitung', email: 'lijing@pathin.eu' },
      ],
    },
    address: { title: 'Vereinsanschrift', body: 'PathIN e.V.\nArabellastraße 5, Apt. 416\n81925 München\nDeutschland' },
    social: { title: 'Social Media', items: [
      { label: 'Instagram · PathIN', url: 'https://instagram.com/pathin.official', display: '@pathin.official' },
      { label: 'Instagram · GraviLens', url: 'https://instagram.com/gravilens.music', display: '@gravilens.music' },
      { label: 'Xiaohongshu · GraviLens', url: 'https://xhslink.com/m/2TVoKkmKWjn', display: 'GraviLens · 引力透镜' },
    ] },
  },
};

export default function V2Kontakt() {
  const lang = useV2Lang();
  const t = COPY[lang];
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await fetch('/api/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      if (res.ok) {
        setStatus('sent');
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  const inputCls = 'w-full bg-transparent border-b py-3 text-[15px] text-white placeholder:text-white/30 focus:outline-none focus:border-white transition-colors';

  return (
    <V2Layout hideFooterContact>
      <PageHeader kicker={t.kicker} title={<DisplayTitle text={t.title} />} lede={t.lede} />

      <Rule />

      <RevealSection className="px-6 md:px-10 py-24">
        <div className="mx-auto max-w-[1400px] grid gap-16 md:grid-cols-12">
          {/* Form */}
          <div className="md:col-span-7">
            <Eyebrow accent>{t.form.title}</Eyebrow>
            <form onSubmit={handleSubmit} className="mt-8 space-y-8">
              <input
                type="text"
                required
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                placeholder={t.form.namePh}
                className={inputCls}
                style={{ borderColor: HAIRLINE }}
                aria-label={t.form.name}
              />
              <input
                type="email"
                required
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                placeholder={t.form.emailPh}
                className={inputCls}
                style={{ borderColor: HAIRLINE }}
                aria-label={t.form.email}
              />
              <input
                type="text"
                required
                value={formData.subject}
                onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                placeholder={t.form.subjectPh}
                className={inputCls}
                style={{ borderColor: HAIRLINE }}
                aria-label={t.form.subject}
              />
              <textarea
                required
                rows={6}
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                placeholder={t.form.messagePh}
                className={`${inputCls} resize-none`}
                style={{ borderColor: HAIRLINE }}
                aria-label={t.form.message}
              />
              <button
                type="submit"
                disabled={status === 'sending'}
                className="px-8 py-3 border text-[14px] tracking-wide hover:bg-white hover:text-black transition-colors disabled:opacity-40"
                style={{ borderColor: 'rgba(255,255,255,0.4)' }}
              >
                {status === 'sending' ? t.form.sending : t.form.submit} →
              </button>
              {status === 'sent' && (
                <p className="text-[14px]" style={{ color: ACCENT }}>{t.form.success}</p>
              )}
              {status === 'error' && (
                <p className="text-[14px] text-orange-400">{t.form.error}</p>
              )}
            </form>
          </div>

          {/* Right column: direct, address, social */}
          <div className="md:col-span-5 md:col-start-9 space-y-12 text-[14px] leading-[1.65] text-white/70">
            <div>
              <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-white/55 mb-4">{t.direct.title}</p>
              <ul className="space-y-2">
                {t.direct.items.map((it) => (
                  <li key={it.email} className="grid grid-cols-12 gap-2 border-b py-2" style={{ borderColor: HAIRLINE }}>
                    <span className="col-span-5 text-white/50 text-[13px]">{it.label}</span>
                    <a href={`mailto:${it.email}`} className="col-span-7 text-white hover:underline">{it.email}</a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-white/55 mb-4">{t.address.title}</p>
              <p className="whitespace-pre-line text-white">{t.address.body}</p>
            </div>
            <div>
              <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-white/55 mb-4">{t.social.title}</p>
              <ul className="space-y-2">
                {t.social.items.map((it) => (
                  <li key={it.url} className="grid grid-cols-12 gap-2 border-b py-2" style={{ borderColor: HAIRLINE }}>
                    <span className="col-span-5 text-white/50 text-[13px]">{it.label}</span>
                    <a href={it.url} target="_blank" rel="noreferrer" className="col-span-7 text-white hover:underline">→ {it.display}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </RevealSection>

      <Rule />
    </V2Layout>
  );
}
